import { Component, OnInit } from '@angular/core';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { ChartType, ChartDataSets, ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { MatDialog } from '@angular/material/dialog';
import { KpiDialogComponent } from '../../../kpi-dialog/kpi-dialog.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-action-evaluation',
  templateUrl: './action-evaluation.component.html',
  styleUrls: ['./action-evaluation.component.scss']
})
export class ActionEvaluationComponent implements OnInit {
  public isLoggedIn: boolean;
  public editObj: boolean = false;
  public editDesc: boolean = false;
  public editMedia: boolean = false;
  public descFocused: boolean = false;
  public objFocused: boolean = false;
  public mediaFocused: boolean = false;
  public descEdited: boolean = false;
  public objEdited: boolean = false;
  public mediaEdited: boolean = false;
  public allowed: boolean;
  public city = history.state.city;
  public action = history.state.action;
  public data: any = [];
  public actions: any[];
  public expanded: boolean = false;
  public kpis: any = [];
  public scores: any = [];
  public description: any = '';
  public objective: any = '';
  public media: any = '';
  public is9: boolean = false;
  public kpi: any;
  public is43: boolean = false;
  public is44: boolean = false;
  public is30: boolean = false;
  public count: number = 0;
  public username: string;
  public kpi30notes: string = 'The result shows the change in price of local products vs non-local products (%)';
  //Chart properties setup
  barChartType: ChartType = 'bar';
  barChartLabels: Label[] = ["Baseline", "M24", "M36", "M42"];
  barChartOptions: ChartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 100
        }
      }]
    }
  }

  barChartOption43: ChartOptions = {  // kpi 43 max value should be 10
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 10
        }
      }]
    }
  }

  barChartOption44: ChartOptions = {  // kpi 44 max value should be 20
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 20
        }
      }]
    }
  }

  public chartColors: any[] = [
    {
      backgroundColor: ["#3498DB", "#3498DB", "#3498DB", "#3498DB"],
      hoverBackgroundColor: ["#85C1E9", "#85C1E9", "#85C1E9", "#85C1E9"]
    },
    {
      backgroundColor: ["#89c2d9", "#89c2d9", "#89c2d9", "#89c2d9"],
      hoverBackgroundColor: ["#a9d6e5", "#a9d6e5", "#a9d6e5", "#a9d6e5"]
    },
    {
      backgroundColor: ["#468faf", "#468faf", "#468faf", "#468faf"],
      hoverBackgroundColor: ["#61a5c2", "#61a5c2", "#61a5c2", "#61a5c2"]
    },
    {
      backgroundColor: ["#2a6f97", "#2a6f97", "#2a6f97", "#2a6f97"],
      hoverBackgroundColor: ["#2c7da0", "#2c7da0", "#2c7da0", "#2c7da0"]
    },
    {
      backgroundColor: ["#01497c", "#01497c", "#01497c", "#01497c"],
      hoverBackgroundColor: ["#014f86", "#014f86", "#014f86", "#014f86"]
    },
    {
      backgroundColor: ["#012a4a", "#012a4a", "#012a4a", "#012a4a"],
      hoverBackgroundColor: ["#013a63", "#013a63", "#013a63", "#013a63"]
    },
    {
      backgroundColor: ["#72efdd", "#72efdd", "#72efdd", "#72efdd"],
      hoverBackgroundColor: ["#80ffdb", "#80ffdb", "#80ffdb", "#80ffdb"]
    },
  ];

  barChartData: any[] = [];
  public kpiScores: ChartDataSets[] = []

  public QuillConfiguration = {
    toolbar: {
      container:
        [
          ['bold', 'italic', 'underline'],
          ['blockquote'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],
          ['image'],
          [{ 'size': ['small', 'medium', 'large', 'huge'] }]
        ],
    },
  }

  constructor(private keycloak: KeycloakService, private req: HttpRequestsService<any>, private router: Router, public dialog: MatDialog, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.keycloak.isLoggedIn().then(res => {
      if (res == true) {
        this.isLoggedIn = true;
      }
    })
    this.req.getCityEvaluationActions(this.city).subscribe((res) => {
      this.data = res;
      this.data.forEach(element => {
        element.expanded = false;
      })
    });
    if (this.keycloak.getUserRoles().includes('MODERATOR')) {
      this.allowed = true;
    } else {
      const keycloakInstance = this.keycloak.getKeycloakInstance();
      if (keycloakInstance.authenticated) {
        this.keycloak.loadUserProfile().then(profile => {
          if (profile['attributes'].City[0] == this.city) {
            this.allowed = true;
          } else {
            this.allowed = false;
          };
        });
      } else {
        this.allowed = false;
      }
    }

    this.req.getCityActionEvaluationDescription(this.city, this.action).subscribe((res) => {
      this.description = res[0].Description;
    })

    this.req.getCityActionEvaluationObjective(this.city, this.action).subscribe((res) => {
      this.objective = res[0].Objective;
    })

    this.req.getCityActionEvaluationMedia(this.city, this.action).subscribe((res) => {
      this.media = res[0].Media;
    })

    this.req.getCityActionEvaluation(this.city, this.action).subscribe((res) => {
      this.kpis = res;
      this.kpis.forEach(element => {
        element.expanded = false;
      });
    });
  }

  onFocus(property: string) {
    if (property === 'description') {
      this.descFocused = true;
    }
    else if (property === 'objective') {
      this.objFocused = true;
    }
    else if (property === 'media') {
      this.mediaFocused = true;
    }
  }

  onContentChanged(property: string, event: any) {
    const htmlContent = event.editor.root.innerHTML;

    if (property === 'description') {
      this.description = htmlContent;
      this.descEdited = true;
    }
    else if (property === 'objective') {
      this.objective = htmlContent;
      this.objEdited = true;
    }
    else if (property === 'media') {
      this.media = htmlContent;
      this.mediaEdited = true;
    }
  }

  onMediaEdit() {
    this.editMedia = !this.editMedia;
  }

  onDescEdit() {
    this.editDesc = !this.editDesc;

  }

  onObjEdit() {
    this.editObj = !this.editObj;

  }

  sanitizeMedia(): SafeHtml {
    const sanitized = this.media.replace(/<\/?[^>]+(>|$)/g, '').trim();
    const media = sanitized === '<p><br></p>' ? '' : sanitized;

    const urlPattern = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/;
    const isUrl = urlPattern.test(media);
    const hyperlink = isUrl ? `<a href="${media.startsWith('www') ? 'http://' + media : media}" target="_blank" rel="noopener noreferrer">${media}</a>` : media;

    return this.sanitizer.bypassSecurityTrustHtml(hyperlink);
  }

  onDescriptionSave() {
    const data = { description: this.description };
    const dataObj = JSON.stringify(data);
    this.req.updateDescription(this.city, this.action, dataObj).subscribe(res => {
      Swal.fire('Done!', 'Description updated!', 'success');
    });
    this.descEdited = false;
  }

  onObjectiveSave() {
    const data = { objective: this.objective };
    const dataObj = JSON.stringify(data);
    this.req.updateObjective(this.city, this.action, dataObj).subscribe(res => {
      Swal.fire('Done!', 'Objective updated!', 'success');
    });
    this.objEdited = false;
  }

  onMediaSave() {
    this.editMedia = false;
    const data = { media: this.media };
    const dataObj = JSON.stringify(data);
    this.req.updateMedia(this.city, this.action, dataObj).subscribe(res => {
      Swal.fire('Done!', 'Media updated!', 'success');
    });
    this.mediaEdited = false;
  }


  onClick(kpi) {
    this.is9 = false;
    this.kpi = kpi;

    if (kpi.substring(0, 2) === '09') {  //check for KPI09
      this.is9 = true;
    }
    if (this.kpi.substring(0, 2) === '43') {
      this.is43 = true;
    }

    this.kpis.forEach(element => {
      if (element.Kpi == kpi) {
        element.expanded = !element.expanded;
        this.kpiScores = [];
        this.barChartData = [];
      }
      else {
        element.expanded = false;
        this.kpiScores = [];
        this.barChartData = [];
      }
    });

    this.kpi = kpi;
    this.req.getKpiActionEvaluationScore(this.city, this.kpi, this.action).subscribe((res) => {
      this.scores = res;
      if (this.scores[0].Keys.length == 0) {
        setTimeout(() => {
          this.kpiScores = [this.scores[0].Baseline_score, this.scores[0].M24_score, this.scores[0].M36_score, this.scores[0].M48_score]
          this.barChartData.push({
            barchartDataObject: [{
              label: 'KPI',
              data: this.kpiScores
            }],
            barChartOptions: this.barChartOptions
          })
        }, 400);
      }
      else {
        setTimeout(() => {
          let chartData = [];

          if (this.kpi.substring(0, 2) === '60') {   //Check for KPI60
            this.count = 2;
          }
          else {
            this.count = this.scores[0].Baseline_score.length;
          }
          for (let i = 0; i < this.count; i++) {
            let dataObject = {
              label: this.scores[0].Keys[i],
              data: [
                this.scores[0].Baseline_score[i],
                this.scores[0].M24_score[i],
                this.scores[0].M36_score[i],
                this.scores[0].M48_score[i]
              ]
            };
            chartData.push(dataObject);
          }
          this.barChartData.push({
            barchartDataObject: chartData,
            barChartOptions: this.barChartOptions
          });
        }, 400);
      }
    });
  }

  onClickAgain(category) {
    this.data.forEach(element => {
      if (element.Action_Cat == category) {
        element.expanded = !element.expanded;
      }
      else {
        element.expanded = false;
        this.actions = [];
      }
    })
    for (let i = 0; i < this.data.length; i++) {
      this.actions.push(this.data[i].Actions);
    }
  }

  onActionClickAgain(action) {
    const actionAgain = action
    this.router.navigateByUrl('/').then(() => { this.router.navigateByUrl(`Evaluation/Action/${action.substring(0, 5)}`, { state: { city: this.city, action: actionAgain } }) });
  }

  onBaseline() {
    this.router.navigateByUrl(`KPI/${this.kpi.substring(0, 2)}/Baseline`, { state: { city: this.city, kpi: this.kpi, action: this.action, step: 'Baseline' } });
  }

  onM18() {
    this.router.navigateByUrl(`KPI/${this.kpi.substring(0, 2)}/M18`, { state: { city: this.city, kpi: this.kpi, action: this.action, step: 'M24' } });
  }

  onM24() {
    this.router.navigateByUrl(`KPI/${this.kpi.substring(0, 2)}/M24`, { state: { city: this.city, kpi: this.kpi, action: this.action, step: 'M24', } });
  }

  onM36() {
    this.router.navigateByUrl(`KPI/${this.kpi.substring(0, 2)}/M36`, { state: { city: this.city, kpi: this.kpi, action: this.action, step: 'M36', } });
  }

  onM42() {
    this.router.navigateByUrl(`KPI/${this.kpi.substring(0, 2)}/M42`, { state: { city: this.city, kpi: this.kpi, action: this.action, step: 'M42' } });
  }

  onInfo() {
    this.dialog.open(KpiDialogComponent, { autoFocus: false, disableClose: false, data: { info: this.scores[0].Info } })
  }
}

